import {featureFlag, featureFlags} from 'app/featureFlags/featureFlags';
import EarlyAccessFeature from 'app/earlyAccess/EarlyAccessFeature';
import {updateEarlyAccessFeature} from 'app/actions/earlyAccessActions';
import {EarlyAccessFeatureStatus} from 'app/earlyAccess/EarlyAccessFeatureStatus';

type ConsentChange = Record<string, string>;

class EarlyAccessFeatureManager {
  private readonly featureList: featureFlag[];
  private consents: Record<string, string> = {};
  private dispatchRedux: any;
  private reduxState: any;

  constructor(dispatchRedux: any, reduxState: any, featureFlagSubset: string[] = []) {
    this.dispatchRedux = dispatchRedux;
    this.reduxState = reduxState;
    this.featureList = featureFlagSubset.length
      ? featureFlags.filter(featureFlag => featureFlagSubset.includes(featureFlag.slug))
      : featureFlags;
    this.consents = this.loadInitConsent();
  }

  getFeatures(): EarlyAccessFeature[] {
    return this.featureList.map(feature => {
      return new EarlyAccessFeature(feature, this.checkConsentDecision(feature.slug), this.updateConsent);
    });
  }

  loadInitConsent = () => {
    return this.featureList.reduce((acc, feature) => {
      const consent = this.reduxState[feature.slug] || EarlyAccessFeatureStatus.PENDING;
      return {...acc, [feature.slug]: consent};
    }, {});
  };

  updateConsent = (consentChange: ConsentChange): void => {
    this.consents = {...this.consents, ...consentChange};
  };

  checkConsentDecision(slug: string): string {
    return this.consents[slug] ?? EarlyAccessFeatureStatus.PENDING;
  }

  submitConsentChanges = (): void => {
    Object.keys(this.consents).forEach(key => {
      this.dispatchRedux(updateEarlyAccessFeature({[key]: this.consents[key]}));
    });
  };
}

export default EarlyAccessFeatureManager;
